"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagGT = function FlagGT(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-56.47,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H-56.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "137.53",
    y: "1",
    width: "136.53",
    height: "268.36",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H80.07V-122H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10-22.93l-4,2L9.7-19.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc855"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,51.9A40.86,40.86,0,0,1-29,11.09,40.71,40.71,0,0,1-10.2-23.31l1,1.64A38.75,38.75,0,0,0-27.07,11.09,38.92,38.92,0,0,0,11.8,50Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-11.56,54.45a11.31,11.31,0,0,0,6.41-1.24A11.3,11.3,0,0,0-.06,49.09a11.33,11.33,0,0,0-6.42,1.24,11.21,11.21,0,0,0-5.08,4.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.06,49.09A11.4,11.4,0,0,0-1.3,42.68a11.3,11.3,0,0,0-4.12-5.09A11.42,11.42,0,0,0-4.18,44,11.26,11.26,0,0,0-.06,49.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-19.7,49.46a11.38,11.38,0,0,0,6.54-.29,11.3,11.3,0,0,0,5.62-3.32,11.33,11.33,0,0,0-6.53.28,11.39,11.39,0,0,0-5.63,3.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-7.53,45.84a11.26,11.26,0,0,0-.29-6.53,11.24,11.24,0,0,0-3.33-5.62,11.35,11.35,0,0,0,.29,6.53,11.24,11.24,0,0,0,3.33,5.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-27.22,42.65a11.28,11.28,0,0,0,6.48.89,11.21,11.21,0,0,0,6.13-2.26,11.3,11.3,0,0,0-6.47-.89,11.25,11.25,0,0,0-6.14,2.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-14.61,41.28a11.31,11.31,0,0,0,.9-6.47A11.33,11.33,0,0,0-16,28.67a11.27,11.27,0,0,0-.89,6.48,11.29,11.29,0,0,0,2.25,6.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-33.43,33.25a11.27,11.27,0,0,0,6.21,2,11.4,11.4,0,0,0,6.44-1.14,11.33,11.33,0,0,0-6.22-2,11.3,11.3,0,0,0-6.43,1.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.78,34.14a11.42,11.42,0,0,0,2-6.22,11.32,11.32,0,0,0-1.15-6.44,11.34,11.34,0,0,0-2,6.22,11.33,11.33,0,0,0,1.14,6.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-37.07,22.9a11.28,11.28,0,0,0,5.65,3.29,11.36,11.36,0,0,0,6.53.24,11.18,11.18,0,0,0-5.65-3.29,11.18,11.18,0,0,0-6.53-.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-24.89,26.43a11.37,11.37,0,0,0,3.29-5.66,11.27,11.27,0,0,0,.24-6.53,11.18,11.18,0,0,0-3.29,5.66,11.27,11.27,0,0,0-.24,6.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-38.61,10.81A11.2,11.2,0,0,0-34,15.44a11.31,11.31,0,0,0,6.25,1.91,11.26,11.26,0,0,0-4.61-4.63,11.34,11.34,0,0,0-6.25-1.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-27.75,17.35a11.18,11.18,0,0,0,4.63-4.62A11.29,11.29,0,0,0-21.2,6.48a11.3,11.3,0,0,0-4.63,4.62,11.34,11.34,0,0,0-1.92,6.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-37.16-.61a11.36,11.36,0,0,0,3.55,5.5A11.23,11.23,0,0,0-27.9,8.07a11.35,11.35,0,0,0-3.54-5.49A11.4,11.4,0,0,0-37.16-.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-27.9,8.07a11.34,11.34,0,0,0,5.5-3.54,11.31,11.31,0,0,0,3.18-5.71,11.33,11.33,0,0,0-5.5,3.54A11.27,11.27,0,0,0-27.9,8.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-31.42-12.95a11.27,11.27,0,0,0,1.2,6.42,11.39,11.39,0,0,0,4.08,5.11,11.21,11.21,0,0,0-1.2-6.43,11.23,11.23,0,0,0-4.08-5.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-26.14-1.42a11.38,11.38,0,0,0,6.43-1.2,11.3,11.3,0,0,0,5.1-4.09A11.27,11.27,0,0,0-21-5.51a11.33,11.33,0,0,0-5.11,4.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-24.56-22.1a11.2,11.2,0,0,0-.57,6.51,11.18,11.18,0,0,0,2.56,6A11.31,11.31,0,0,0-22-16.09a11.34,11.34,0,0,0-2.56-6Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-22.57-9.57A11.28,11.28,0,0,0-16.06-9a11.41,11.41,0,0,0,6-2.56,11.31,11.31,0,0,0-6.52-.57,11.26,11.26,0,0,0-6,2.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.84-28.46a11.24,11.24,0,0,0-1.52,6.35,11.32,11.32,0,0,0,1.64,6.33,11.3,11.3,0,0,0,1.53-6.36,11.25,11.25,0,0,0-1.65-6.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.72-15.78a11.3,11.3,0,0,0,6.36,1.52A11.31,11.31,0,0,0-5-15.91a11.3,11.3,0,0,0-6.36-1.52,11.31,11.31,0,0,0-6.33,1.65Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-14.45-19.12a11.24,11.24,0,0,0,6.22-2,11.37,11.37,0,0,0,4.55-4.69,11.24,11.24,0,0,0-6.22,2,11.25,11.25,0,0,0-4.55,4.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,51.9V50A38.93,38.93,0,0,0,50.68,11.08,38.75,38.75,0,0,0,32.75-21.67l1-1.64A40.69,40.69,0,0,1,52.62,11.08,40.86,40.86,0,0,1,11.8,51.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35.16,54.45a11.34,11.34,0,0,1-6.42-1.24,11.32,11.32,0,0,1-5.08-4.12,11.33,11.33,0,0,1,6.42,1.24,11.26,11.26,0,0,1,5.08,4.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.66,49.09a11.31,11.31,0,0,1,1.24-6.41A11.3,11.3,0,0,1,29,37.59,11.25,11.25,0,0,1,27.78,44a11.26,11.26,0,0,1-4.12,5.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.29,49.46a11.35,11.35,0,0,1-6.53-.29,11.39,11.39,0,0,1-5.63-3.32,11.33,11.33,0,0,1,6.53.28,11.3,11.3,0,0,1,5.63,3.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.13,45.84a11.26,11.26,0,0,1,.29-6.53,11.23,11.23,0,0,1,3.32-5.62,11.25,11.25,0,0,1-.28,6.53,11.31,11.31,0,0,1-3.33,5.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.82,42.65a11.28,11.28,0,0,1-6.48.89,11.28,11.28,0,0,1-6.14-2.26,11.35,11.35,0,0,1,6.48-.89,11.28,11.28,0,0,1,6.14,2.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.2,41.28a11.32,11.32,0,0,1-.89-6.47,11.33,11.33,0,0,1,2.26-6.14,11.27,11.27,0,0,1,.89,6.48,11.21,11.21,0,0,1-2.26,6.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M57,33.25a11.33,11.33,0,0,1-6.22,2,11.4,11.4,0,0,1-6.44-1.14,11.3,11.3,0,0,1,6.22-2A11.35,11.35,0,0,1,57,33.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M44.38,34.14a11.33,11.33,0,0,1-2-6.22,11.33,11.33,0,0,1,1.14-6.44,11.33,11.33,0,0,1,2,6.22,11.33,11.33,0,0,1-1.14,6.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60.67,22.9A11.33,11.33,0,0,1,55,26.19a11.36,11.36,0,0,1-6.53.24,11.18,11.18,0,0,1,5.65-3.29,11.18,11.18,0,0,1,6.53-.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M48.49,26.43a11.37,11.37,0,0,1-3.29-5.66A11.36,11.36,0,0,1,45,14.24a11.32,11.32,0,0,1,3.29,5.66,11.36,11.36,0,0,1,.24,6.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M62.21,10.81a11.2,11.2,0,0,1-4.61,4.63,11.31,11.31,0,0,1-6.25,1.91A11.26,11.26,0,0,1,56,12.72a11.31,11.31,0,0,1,6.25-1.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.35,17.35a11.25,11.25,0,0,1-4.64-4.62A11.27,11.27,0,0,1,44.8,6.48a11.3,11.3,0,0,1,4.63,4.62,11.25,11.25,0,0,1,1.92,6.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60.75-.61a11.18,11.18,0,0,1-3.54,5.5A11.27,11.27,0,0,1,51.5,8.07,11.35,11.35,0,0,1,55,2.58,11.41,11.41,0,0,1,60.75-.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.5,8.07A11.3,11.3,0,0,1,46,4.53a11.31,11.31,0,0,1-3.18-5.71,11.37,11.37,0,0,1,5.5,3.54A11.27,11.27,0,0,1,51.5,8.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M55-12.95a11.27,11.27,0,0,1-1.2,6.42,11.33,11.33,0,0,1-4.09,5.11,11.31,11.31,0,0,1,1.21-6.43A11.23,11.23,0,0,1,55-12.95Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.73-1.42a11.36,11.36,0,0,1-6.42-1.2A11.4,11.4,0,0,1,38.2-6.71a11.29,11.29,0,0,1,6.43,1.2,11.24,11.24,0,0,1,5.1,4.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M48.16-22.1a11.29,11.29,0,0,1,.57,6.51,11.26,11.26,0,0,1-2.56,6,11.4,11.4,0,0,1-.57-6.52,11.34,11.34,0,0,1,2.56-6Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.17-9.57A11.28,11.28,0,0,1,39.66-9a11.37,11.37,0,0,1-6-2.56,11.31,11.31,0,0,1,6.52-.57,11.26,11.26,0,0,1,6,2.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.44-28.46A11.24,11.24,0,0,1,43-22.11a11.32,11.32,0,0,1-1.64,6.33,11.38,11.38,0,0,1-1.53-6.36,11.25,11.25,0,0,1,1.65-6.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.32-15.78A11.3,11.3,0,0,1,35-14.26a11.31,11.31,0,0,1-6.33-1.65A11.3,11.3,0,0,1,35-17.43a11.31,11.31,0,0,1,6.33,1.65Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.05-19.12a11.24,11.24,0,0,1-6.22-2,11.31,11.31,0,0,1-4.55-4.69,11.24,11.24,0,0,1,6.22,2,11.25,11.25,0,0,1,4.55,4.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-10.48,42.86l-7.08,7.08L-21,43l10.47-10.47L-7.09,36l-1,3a9.9,9.9,0,0,1-2.38,3.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#966446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.8-9.38-10.58,29a2.47,2.47,0,0,0,0,3.49l1.74,1.74,7-7L26.05-4.15l3.49-3.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1.14,23.05a2.47,2.47,0,0,0-.72,1.74v2.47L26.05-4.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#966446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.54-7.63,27.8-9.38,26.05-7.63,27.8-5.89l1.74,1.75L48.73-26.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36,42.86l7.07,7.08,3.49-7L36.12,32.49,32.64,36l1,3A9.81,9.81,0,0,0,36,42.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#966446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-2.25-9.38,36.12,29a2.46,2.46,0,0,1,0,3.49l-1.74,1.74-7-7L-.51-4.15-4-7.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.68,23.05a2.47,2.47,0,0,1,.72,1.74v2.47L-.51-4.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#966446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-4-7.63l1.75-1.75L-.51-7.63-2.25-5.89-4-4.14-23.19-26.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1.55,41.41.19,43A460.11,460.11,0,0,1,35.12,8.17s-14.53,9-36.67,33.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-6.45,48.53a1.53,1.53,0,0,1-.1-2.16l3.71-4.07a1.53,1.53,0,0,1,2.16-.1,1.54,1.54,0,0,1,.1,2.16L-4.3,48.43a1.52,1.52,0,0,1-2.15.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3,40.13l-1,.44c-.9.45-3.25,1.78-3.66,3.68a3,3,0,0,0,.78,2.6,1.53,1.53,0,0,1,.29-.47l.47-.52a1.73,1.73,0,0,1-.39-1.36c.25-1.19,1.84-2.25,2.83-2.77L.81,45.79l1.11-1.22Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc855"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.07,43.33l-1.73,1.58A460.76,460.76,0,0,0-9.6,10.09s14.54,9,36.67,33.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32,50.45a1.54,1.54,0,0,0,.1-2.16l-3.72-4.07a1.52,1.52,0,0,0-2.25,2.05l3.71,4.08a1.53,1.53,0,0,0,2.16.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.48,42.05l1,.45c.89.44,3.25,1.77,3.65,3.67a2.93,2.93,0,0,1-.77,2.6,1.71,1.71,0,0,0-.29-.48l-.47-.51A1.77,1.77,0,0,0,32,46.42c-.26-1.19-1.84-2.25-2.84-2.78L24.71,47.7,23.6,46.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc855"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.53-20.87A3,3,0,0,0,13.74-22a2.91,2.91,0,0,0-2.91-2.92A2.92,2.92,0,0,0,7.91-22,2.92,2.92,0,0,0,9.1-19.62C8-11.16,16.39-10.51,19.57-9.32,24.4-7.53,30.46-3.9,30.07,6.26c-.36,9.88-6.61,19.4-6.61,19.4l5.18-7c-1.89,8-6.32,18.22-16.84,30.37A110.8,110.8,0,0,0,25,32.87c-4.42,10.4-9.31,20-9.31,20s8.66-11.26,15.67-30.74c8.49-23.62-9.37-37.8-17.83-43Zm0,0",
    transform: "translate(194 123)",
    fill: "#69b469"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "192.2",
    y: "137",
    width: "7.78",
    height: "3.89",
    fill: "#f4e08f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.09,17.89A3.89,3.89,0,0,1-1.8,21.77a3.89,3.89,0,0,1-3.89-3.88A3.89,3.89,0,0,1-1.8,14a3.89,3.89,0,0,1,3.89,3.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#ecd077"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.09-7.38A3.89,3.89,0,0,1-1.8-3.49,3.89,3.89,0,0,1-5.69-7.38,3.89,3.89,0,0,1-1.8-11.27,3.89,3.89,0,0,1,2.09-7.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#ecd077"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.52-3.5a3.89,3.89,0,0,0,3.89-3.88,3.89,3.89,0,0,0-3.89-3.89H-1.81A3.89,3.89,0,0,1,2.08-7.38,3.88,3.88,0,0,1-1.81-3.5,3.89,3.89,0,0,1-5.7-7.38C-5.7-.85-.23,7,1.53,14a14.35,14.35,0,0,1,.55,3.89,3.88,3.88,0,0,1-3.89,3.88H21.52a3.89,3.89,0,0,0,3.89-3.88c0-6.53-5.47-14.42-7.23-21.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#fcf0a8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.08-7.38A3.89,3.89,0,0,1-1.81-3.49H21.52a3.89,3.89,0,0,0,3.89-3.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#f4e08f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.08,17.89a3.88,3.88,0,0,1-3.89,3.88H21.52a3.89,3.89,0,0,0,3.89-3.88Zm0,0",
    transform: "translate(194 123)",
    fill: "#f4e08f"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagGT;
exports["default"] = _default;